import styled from "styled-components";


export const ScreenBackground = styled.div`
    background: #f8f9f9;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`

export const RedirectScreenContainer = styled.div`
    background: #FFF;
    height: calc(100vh - 10px);
    width: calc(100vw - 30px);
    max-width: 450px;
    border: 1px solid #e4e5e6;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
`

export const RedirectHeading = styled.div`
    font-family: Outfit;
    font-size: 28px;
    font-weight: 800;
    line-height: 35px;
    color: #000;
    text-align: center;
`

export const TickListItem = styled.div`
    display: flex;
    width: 80%;
    display: flex;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    gap: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
`

export const TickListText = styled.div`
    width: ${props => props?.right ? '40%' : '60%'};
    display: flex;
    justify-content: ${props => props?.right && 'right'};
`

export const TakeToAppButton = styled.div`
    height: 40px;
    width: 250px;
    border-radius: 30px;
    background-color: #394fcc;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    margin: 160px 0 5px 0;
    cursor: pointer;
`

export const RedirectStrip = styled.div`
    width: 100%;
    height: 40px;
    font-family: Outfit;
    font-size: 16px;
    color: #000;
    position: fixed;
    top: 0;
    z-index: 999;
    background: ${({ theme }) => theme?.themeC5};
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    gap: 4px;
    cursor: default;
`

export const RedirectStripButton = styled.div`
    color: #000;
    text-align: center;
    font-size: 12px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    align-items: center;
    cursor: pointer;
    background: #FFF;
    padding: 5px;
    border-radius: 8px;
`